<template>
  <div class="financial-institution-list-item">
    <div class="meta">
      <router-link :to="route" class="name">{{ name }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: null,
      default: undefined,
    },
    code: {
      type: null,
      default: undefined,
    },
    route: {
      type: null,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.financial-institution-list-item {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  align-items: flex-start;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .meta {
    display: block;

    flex-grow: 1;
  }
}

.meta > .name {
  display: inline-block;
  font-size: 20px;

  &:hover {
    color: black;
  }
}
</style>
